<script>
  import API from '../Stores/API';
  import Trail from '../Components/Trail';
  import View from '../Stores/View';

  let context = '';
  let user = $API.data.user;
  let form = false;

  async function setSave() {
    const values = new FormData(form);
    const data = Object.fromEntries(values.entries());
    await API.getRequest('user', 'post', data);
    await API.setData();
    View.setView('dashboard', {notice: 'Jouw gegevens zijn aangepast!'});
  }
</script>

{#if $API.data}
  <Trail path="{[['Account', () => View.setView('dashboard')], [user.name]]}"/>

  <section class="pt-6 bg-dark">
    <div class="container-lg">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 text-center text-white">
          <h1 class="display-3 mb-4"><span class="text-underline-warning">{user.name}</span></h1>
          <p class="fs-lg">Hieronder kun je jouw gegevens aanpassen. Jouw e-mailadres en wachtwoord kun je gebruiken om in te loggen.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="position-relative pt-4 pb-10 bg-dark">
    <div class="container-lg">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6">
          <form bind:this="{form}" on:submit|preventDefault="{setSave}">
            <div class="form-group">
              <label class="visually-hidden" for="name">Naam</label>
              <input class="form-control" id="name" name="name" type="text" required="required" value="{user.name}" placeholder="Naam"/>
            </div>
            <div class="form-group">
              <label class="visually-hidden" for="phone">Telefoon</label>
              <input class="form-control" id="phone" name="phone" type="text" required="required" value="{user.phone}" placeholder="Telefoon"/>
            </div>
            <div class="form-group">
              <label class="visually-hidden" for="email">E-mail</label>
              <input class="form-control" id="email" name="email" type="email" required="required" value="{user.email}" placeholder="E-mailadres"/>
            </div>
            <div class="form-group">
              <label class="visually-hidden" for="password">Wachtwoord</label>
              <input class="form-control" id="password" name="password" type="password" value="{user.password || ''}" placeholder="Wachtwoord"/>
            </div>
            <div class="form-group form-check">
              <input type="checkbox" class="form-check-input" id="newsletter" name="newsletter" value="1" checked="{user.newsletter}">
              <label class="form-check-label text-white" for="newsletter">Ik wil de Eeuwige Tuinen nieuwsbrief ontvangen.</label>
            </div>
            <button class="btn w-100 mt-4 btn-primary-light">Opslaan</button>
            <button class="btn w-100 mt-4 btn-primary" on:click="{event => { View.setView('dashboard') }}">Annuleren</button>
          </form>
        </div>
      </div>
    </div>
  </section>
{/if}